import 'swiper/css';
import 'swiper/css/navigation';
import '../../css/home/index.scss';
import { winW } from "../share/components/_globeVar.js";
import Swiper from 'swiper';
import { Navigation, A11y, FreeMode } from 'swiper/modules';

$(function() {

    // $('.exh_col').hover(function() {
    //     $(this).addClass('active');
    // }, function() {
    //     $(this).removeClass('active');
    // });
    if (winW > 950) {
        const $exh_col = $('.exh_col');
        $exh_col.eq(0).addClass('active');
        $exh_col.mouseenter(function() {
            $exh_col.removeClass('active');
            $(this).addClass('active');
            // TweenMax.to($(this).find('.exh_caption'), .4, { delay:.3, opacity: 1, display: 'block', ease: Power1.easeOut })
        });
    }
    // var tween = new TimelineMax({ delay: .5 })
    //     .to(".cf_1", 1.5, { opacity: 1 })
    //     .to(".cf_txt_center", 4, { opacity: 1, scale: 0.097, ease: Quart.easeInOut }, '-=.2')
    //     .from(".cf_txt_circle_4", 5, { opacity: 0, scale: 4, ease: Quart.easeInOut }, '-=4.95')
    //     .from(".cf_txt_circle_3", 3, { opacity: 0, scale: 4, ease: Quart.easeInOut }, '-=2.95')
    //     .from(".cf_txt_circle_2", 2, { opacity: 0, scale: 4, ease: Quart.easeInOut }, '-=1.9')
    //     .from(".cf_txt_circle_1", 1.5, { opacity: 0, scale: 4, ease: Quart.easeInOut }, '-=1.4')
    //     .to(".cf_1", 4.5, { opacity: 0, scale: .5, ease: Sine.easeInOut }, '-=1.9')
    //     .to(".cf_2", 4, { opacity: 1, ease: Power1.easeInOut }, '-=1.8')
    //     .to(".cf_sun", 3.2, { scale: .35, y: '-13%', ease: Quart.easeInOut }, '-=1.4')
    //     .fromTo(".cf_text", 3, { opacity: 0, scale: 3 }, { opacity: 1, scale: .7, y: '-7%', ease: Quart.easeInOut }, '-=3')
    //     .fromTo(".cf_ground", 3, { opacity: 0, scale: 2, y: '50%' }, { opacity: 1, scale: .82, y: '-26.5%', ease: Quart.easeInOut }, '-=2.6')
    //     .from(".cf_bg", 5, { opacity: 0, ease: Power1.easeInOut }, '-=4')
    //     .from(".cf_sec", 4, { width: 'calc(100% + 120px)', left: '-120px', ease: Quart.easeInOut }, '-=4.6')
    //     .from(".header", 6, { opacity: 0, ease: Power1.easeOut }, '-=4')
    //     .from(".cf_title", 4, { opacity: 0, ease: Power0.easeOut }, '-=2')

    //     var controller = new ScrollMagic.Controller();
    //     new ScrollMagic.Scene({
    //         triggerElement: "#trigger3",
    //         duration: 200
    //     })
    //     .setTween(tween)
    //     .addTo(controller);
    function pureFadeIn(elem, display) {
        var el = document.getElementById(elem);
        el.style.opacity = 0;
        el.style.display = display || "block";

        (function fade() {
            var val = parseFloat(el.style.opacity);
            if (!((val += .05) > 1)) {
                el.style.opacity = val;
                requestAnimationFrame(fade);
            }
        })();
    };

    function pureFadeOut(elem) {
        var el = document.getElementById(elem);
        el.style.opacity = 1;

        (function fade() {
            if ((el.style.opacity -= .04) < 0) {
                el.style.display = "none";
            } else {
                requestAnimationFrame(fade);
            }
        })();
    };

    function setCookie(name, value, days) {
        var expires = "";
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "") + expires + "; path=/";
    }

    function getCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }

    function eraseCookie(name) {
        document.cookie = name + '=; Max-Age=-99999999;';
    }

    function cookieConsent() {
        if (!getCookie('purecookieDismiss')) {
            pureFadeIn("cookieConsentContainer");
        }
        $('.cookieButton').click(function() {
            purecookieDismiss();
        });
    }

    function purecookieDismiss() {
        setCookie('purecookieDismiss', '1', 7);
        pureFadeOut("cookieConsentContainer");
    }

    // window.onload = function () {
    //     cookieConsent();
    // };

    if ($(".collection_swiper").length > 0) {

        const swiper_el = '.collection_swiper';
        const container = swiper_el + ' .swiper';
        const pagination = swiper_el + ' .swiper-pagination';
        const button_next = swiper_el + ' .swiper-button-next';
        const button_prev = swiper_el + ' .swiper-button-prev';

        const $swiper = new Swiper(container, {
            modules: [Navigation, A11y, FreeMode],
            grabCursor: true,
            slidesPerView: 3.7,
            speed: 400,
            freeMode: true,
            pagination: {
                el: pagination,
                type: 'fraction',
                clickable: true,
            },
            navigation: {
                nextEl: button_next,
                prevEl: button_prev,
            },
            a11y: {
                enabled: true,
                firstSlideMessage: "第一則",
                lastSlideMessage: "最後一則",
                paginationBulletMessage: "到第 {{index}} 則",
            },
            breakpoints: {
                320: {
                    slidesPerView: 2.1,
                },
                480: {
                    slidesPerView: 2.1,
                },
                950: {
                    slidesPerView: 3.7,
                }
            }
        });

    }


    if (winW > 950) {
        gsap.set(".header", { x: -120, opacity: 0 })
    } else {
        gsap.set(".header", { y: -100, opacity: 0 })
    }

    let _sun_y = '-14%';
    let _sun_scale = .37;
    let _text_y = '-14%';
    let _text_scale = .63;
    let _ground_y = '-26.5%';
    if (winW <= 950) {
        _sun_y = '-52%';
        _text_y = '-300%';
        _text_scale = .7;
        _ground_y = '-20%';
    }
    if (winW <= 480) {
        _sun_y = '-66%';
        _sun_scale = .5;
        _text_y = '-360%';
        _text_scale = .8;
        _ground_y = '15%';
    }

    gsap.registerPlugin(ScrollTrigger);

    const timeline1 = gsap.timeline({ paused: true })
        .to(".cf_txt_center", { duration: 4, opacity: 1, scale: 0.21, ease: 'power2.inOut' }, '-=1.4')
        .from(".cf_txt_circle_4", { duration: 5, opacity: 0, scale: 4, ease: 'quart.inOut' }, '-=4.5')
        .from(".cf_txt_circle_3", { duration: 3, opacity: 0, scale: 4, ease: 'quart.inOut' }, '-=2.95')
        .from(".cf_txt_circle_2", { duration: 2, opacity: 0, scale: 4, ease: 'quart.inOut' }, '-=1.9')
        .from(".cf_txt_circle_1", { duration: 1.5, opacity: 0, scale: 4, ease: 'quart.inOut' }, '-=1.4')
        .to(".cf_1", { duration: 2, scale: .5, ease: 'power0.out' }, '-=1.5')
        .to(".cf_txt_center,.cf_txt_circle", { duration: 2, opacity: 0, ease: 'power0.out' }, '-=1.5')
        .to(".cf_2", { duration: 4, opacity: 1, ease: 'power1.inOut' }, '-=1.5')
        .to(".cf_sun", { duration: 3.5, scale: _sun_scale, y: _sun_y, ease: 'quart.inOut' }, '-=2')
        .fromTo(".cf_text", { opacity: 0, scale: 3 }, { duration: 4, opacity: 1, scale: _text_scale, y: _text_y, ease: 'quart.inOut' }, '-=3.5')
        .fromTo(".cf_ground", { opacity: 0, scale: 2.5, y: '50%' }, { duration: 4, opacity: 1, scale: .825, y: _ground_y, ease: 'quart.inOut' }, '-=3')
        .from(".cf_bg", { duration: 5, opacity: 0, ease: 'power1.inOut' }, '-=4')
        .from(".cf_sec", { duration: 4, width: '100%', ease: 'quart.inOut' }, '-=4.6')
        .to(".header", { duration: 4, x: 0, y: 0, opacity: 1, ease: 'quart.inOut' }, '-=4.6')
        .from(".cf_title", { duration: 3, opacity: 0, ease: 'power0.out' }, '-=2')

    if (winW > 1200) {
        let _circle = 21;
        if (winW <= 950) _circle = 35;
        if (winW <= 480) _circle = 45;
        gsap.timeline({
                scrollTrigger: {
                    trigger: '.sp_about_1',
                    endTrigger: '.sp_about_3',
                    start: "top top",
                    toggleActions: "play none none reverse",
                    scrub: true,
                    pin: true,
                    invalidateOnRefresh: true,
                }
            })
            .to(".cf_sec, .about_bg", { duration: 2, clipPath: 'circle(' + _circle + 'vw at center)', ease: 'power0.out' })
        gsap.timeline({
                scrollTrigger: {
                    trigger: '.sp_about_2',
                    start: "top 80%",
                    toggleActions: "play none none reverse",
                }
            })
            .to(".about_sec", { duration: 1, opacity: 1, ease: 'power0.out' })
            .from(".about_title", { duration: 1, opacity: 0, ease: 'sine.inOut' }, '-=.2')
        gsap.timeline({
                scrollTrigger: {
                    trigger: '.sp_about_2',
                    start: "top top",
                    toggleActions: "play none none reverse"
                }
            })
            .add(function() {
                timeline1.progress(1).pause();
                gsap.to(".header", { duration: .6, x: 0, opacity: 1, ease: 'quart.inOut' })
            })
            .from(".about_center_bg", { duration: 1, opacity: 0, ease: 'power0.out' }, 'anchor2')
            .from(".about_hands", { duration: 2, opacity: 0, ease: 'sine.inOut' }, 'anchor2')
            .from(".about_txt", { duration: 2, opacity: 0, ease: 'sine.inOut' }, 'anchor2')
    }

    if (winW > 1200) {
        gsap.timeline({
                scrollTrigger: {
                    trigger: '.sp_about_3',
                    endTrigger: '.sp_exhibition',
                    start: "top top",
                    toggleActions: "play none none reverse",
                    scrub: true,
                    pin: true,
                }
            })
            .to(".circle_left", { x: '-46.5%', ease: 'power0.inOut' }, 'anchor3')
            .to(".circle_right", { x: '46.5%', ease: 'power0.inOut' }, 'anchor3')
            .from(".about_inner", { duration: .2, opacity: 0, ease: 'sine.inOut' })
    } else if (winW > 480) {
        // gsap.timeline({
        //         scrollTrigger: {
        //             trigger: '.sp_about_3',
        //             endTrigger: '.sp_exhibition',
        //             start: "top top",
        //             toggleActions: "play none none reverse",
        //             // scrub: true,
        //             // pin: true,
        //         }
        //     })
        //     .to(".circle_left", { y: '-42%', ease: 'power0.inOut' }, 'anchor3')
        //     .to(".circle_right", { y: '55%', ease: 'power0.inOut' }, 'anchor3')
        //     .from(".about_inner", { duration: .2, opacity: 0, ease: 'sine.inOut' })
    }

    let _start = 'top';
    if (winW <= 950) _start = '20%';
    if (winW > 1200) {
        gsap.timeline({
                scrollTrigger: {
                    trigger: '.sp_exhibition',
                    endTrigger: '.sp_exhibition_1',
                    start: "top " + _start,
                    toggleActions: "play none none reverse",
                    scrub: true,
                    pin: true,
                }
            })
            .to(".cf_sec, .about_sec", { y: '-100vh', ease: 'power0.out' })
    }

    gsap.timeline({ scrollTrigger: { trigger: '.exhibition_sec', start: "top 70%", toggleActions: "play none none reverse", } })
        .from(".exhibition_sec .maintitle_row", { duration: .7, opacity: 0, y: 100, ease: 'circ.out' })
        .from(".exh_item", {
            duration: .8,
            opacity: 0,
            x: -1000,
            stagger: { // wrap advanced options in an object
                each: 0.13,
                from: "end",
                ease: "quart.out",
            }
        })

    gsap.timeline({ scrollTrigger: { trigger: '.collection_sec', start: "top 70%", toggleActions: "play none none reverse", } })
        .from(".collection_sec .maintitle_row", { duration: .7, opacity: 0, y: 100, ease: 'circ.out' })
        .from(".collect_item", {
            duration: .8,
            opacity: 0,
            x: 1000,
            stagger: { // wrap advanced options in an object
                each: 0.13,
                ease: "quart.out",
            }
        })
        .from(".swiper_controller", { duration: .6, opacity: 0, x: -120, ease: 'quart.Out' }, '-=.2')

    gsap.timeline({
            scrollTrigger: {
                trigger: '.collection_sec',
                endTrigger: '.collection_sec_end',
                start: "top 50%",
                toggleActions: "play none none reverse",
                scrub: true,
            }
        })
        .to(".moon_block", { x: '150%', y: '-80%', ease: 'power0.out' })

    gsap.timeline({ scrollTrigger: { trigger: '.grid_sec', start: "top 70%", toggleActions: "play none none reverse", } })
        .from(".grid_sec .maintitle_row", { duration: .7, opacity: 0, y: 100, ease: 'circ.out' })
        .from(".grid_item", {
            duration: .6,
            opacity: 0,
            y: 50,
            stagger: {
                each: 0.05,
                ease: "quart.out",
            }
        })

    imagesLoaded("html, body", function() {
        if (!getCookie('enterThisSite')) {
            setCookie('enterThisSite', '1', 1);
            timeline1.play();
        } else {
            timeline1.progress(1).pause();
            // gsap.set(".cf_sec", { width: 'calc(100% - 7.5rem)' })
        }
    });

});